import { render, staticRenderFns } from "./SaleReceiptView.vue?vue&type=template&id=f8274434&scoped=true"
import script from "./SaleReceiptView.vue?vue&type=script&lang=js"
export * from "./SaleReceiptView.vue?vue&type=script&lang=js"
import style0 from "./SaleReceiptView.vue?vue&type=style&index=0&id=f8274434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8274434",
  null
  
)

export default component.exports